import { rect, cRect } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

// Head y=8-19, neck y=20-21, torso y=22-35, hips y=36-38, legs y=39-52
export const body_average: Hull = {
  id: 'body_average',
  name: 'Average',
  drawBody: (ctx, p) => {
    // Head
    rect(ctx, 26, 8, 12, 12, p.light);
    rect(ctx, 26, 8, 1, 12, p.shadow);
    rect(ctx, 37, 8, 1, 12, p.shadow);
    rect(ctx, 27, 8, 10, 1, p.shadow);
    rect(ctx, 27, 19, 10, 1, p.shadow);
    // Neck
    rect(ctx, 30, 20, 4, 2, p.light);
    // Shoulders (wider than torso)
    cRect(ctx, 22, 16, 2, p.light);
    // Arms (x=23-26 left, x=37-40 right — matches where tops draw sleeves)
    rect(ctx, 23, 24, 4, 12, p.light);
    rect(ctx, 37, 24, 4, 12, p.light);
    // Torso
    rect(ctx, 25, 24, 14, 12, p.light);
    rect(ctx, 25, 24, 1, 12, p.shadow);
    rect(ctx, 38, 24, 1, 12, p.shadow);
    // Hips
    rect(ctx, 25, 36, 14, 3, p.shadow);
    // Left leg
    rect(ctx, 25, 39, 6, 14, p.light);
    rect(ctx, 25, 39, 1, 14, p.shadow);
    // Right leg
    rect(ctx, 33, 39, 6, 14, p.light);
    rect(ctx, 38, 39, 1, 14, p.shadow);
  },
  mounts: {
    [SLOT.HEAD]:   { anchor: { x: 32, y: 8 } },
    [SLOT.FACE]:   { anchor: { x: 32, y: 13 } },
    [SLOT.HAT]:    { anchor: { x: 32, y: 8 } },
    [SLOT.TORSO]:  { anchor: { x: 32, y: 22 } },
    [SLOT.WAIST]:  { anchor: { x: 32, y: 36 } },
    [SLOT.FOOT_L]: { anchor: { x: 28, y: 52 } },
    [SLOT.FOOT_R]: { anchor: { x: 36, y: 52 } },
  },
};
